import React,{Component} from 'react';
import{Route,Link,Switch} from 'react-router-dom'
import firebase from '../config'
import {Box,Button, useRadioGroup} from '@material-ui/core'
import { Popconfirm} from 'antd';
import { Table, Tag, Space } from 'antd';


export default class Booking extends Component{
    constructor(){
        super()
        this.state={
            data :[]
        }
    }
    componentDidMount(){
        var temp = []
        firebase.firestore().collection('bookings').get().then(snap =>{
            snap.forEach(doc => {
                var obj =doc.data()
                obj.id = doc.id;
                temp.push(obj);
                console.log(obj)
                setTimeout(()=>{
                    this.setState({
                        data : temp
                    })
                },1000)

            })
            
        })
    }
    confirm(id){
        firebase.firestore().collection('queries').doc(id).delete().then(()=>{
            alert('deleted')
        })
    }
    columns = [
        {
          title: 'Test/Pack Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Type',
          dataIndex: 'type',
          key: 'type',
        },
        {
          title: 'User Address',
          dataIndex: 'adress',
          key: 'adress',
        },
        {
            title: 'User Phone',
            dataIndex: 'phone',
            key: 'phone',
          },
          {
            title: 'Test Price',
            dataIndex: 'price',
            key: 'price',
          },
          {
            title: 'User name',
            dataIndex: 'name',
            key: 'userName',
          },
          {
            title: 'User Age',
            dataIndex: 'Age',
            key: 'userage',
          },
          {
            title: 'User gender',
            dataIndex: 'gender',
            key: 'gender',
          },
          {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
          },
          {
            title: 'Payment Status',
            dataIndex: 'paymentStatus',
            key: 'paymentStatus',
          },
      ];

    render(){
       let data = this.state.data
       let arr=[];
       data.forEach(e =>{
            var obj = {...e}
            obj.Age = obj.user.Age;
            obj.name = obj.user.name;
            obj.gender = obj.user.gender;
            arr.push(obj);
       })

        if(data.length > 0) return(
           
                <Table dataSource={arr} columns={this.columns} />

        )
        else 
            return <h2>No Queries</h2>
    }
}

